var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppsflyer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45.93 45.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#82b341;}.b{fill:#0090d0;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "appsflyer-default") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M118.55,259.54l6.79,12.94a3.2,3.2,0,0,0,2.55,1.6l13.86,0a1,1,0,0,0,.87-1.6l-6.8-12.94a3.19,3.19,0,0,0-2.55-1.6l-13.86,0h-0.06a1,1,0,0,0-.81,1.6",
    transform: "translate(-118.35 -244.99)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M144.88,274.62L149,282.3a1.9,1.9,0,0,0,1.53.94l8.26-.09a0.58,0.58,0,0,0,.51-1l-4.11-7.68a1.9,1.9,0,0,0-1.53-.94l-8.26.09h0a0.58,0.58,0,0,0-.48,1",
    transform: "translate(-118.35 -244.99)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M144.93,245.46l-8.26,10.6a2.9,2.9,0,0,0-.17,2.9l6.9,12.88a1,1,0,0,0,1.87.28l8.26-10.6a2.89,2.89,0,0,0,.17-2.9l-6.9-12.89a1.22,1.22,0,0,0-1.06-.75,1.1,1.1,0,0,0-.81.47",
    transform: "translate(-118.35 -244.99)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M143,274.75l-4.92,6.32a1.72,1.72,0,0,0-.1,1.73l4.11,7.68a0.62,0.62,0,0,0,1.12.17l4.92-6.32a1.73,1.73,0,0,0,.1-1.73l-4.11-7.68a0.73,0.73,0,0,0-.63-0.45,0.65,0.65,0,0,0-.48.28",
    transform: "translate(-118.35 -244.99)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppsflyer);
export default __webpack_public_path__ + "static/media/appsflyer.35c962592f3e71e3955ad87d25805543.svg";
export { ForwardRef as ReactComponent };